import { render, staticRenderFns } from "./invest_bank.vue?vue&type=template&id=5ca03f5e&scoped=true"
import script from "./invest_bank.vue?vue&type=script&lang=js"
export * from "./invest_bank.vue?vue&type=script&lang=js"
import style0 from "./invest_bank.vue?vue&type=style&index=0&id=5ca03f5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca03f5e",
  null
  
)

export default component.exports